import { msg } from '@lingui/macro'

import { Handing } from '../__generated/model/index.js'

export const NO_HANDING = 'none'
export const NO_VARIANT = 'none'

export enum CabinetWidth {
  W0 = 0,
  W1 = 25.4,
  W1_25 = 31.75,
  W1_5 = 38.1,
  W1_75 = 44.45,
  W2 = 50.8,
  W2_25 = 57.15,
  W2_5 = 63.5,
  W2_75 = 69.85,
  W3 = 76.2,
  W3_25 = 82.55,
  W3_5 = 88.9,
  W3_75 = 95.25,
  W4 = 101.6,
  W4_25 = 107.95,
  W4_5 = 114.3,
  W4_75 = 120.65,
  W5 = 127,
  W6 = 152.4,
  W12 = 304.8,
  W18 = 457.2,
  W24 = 609.6,
  W28_25 = 717.55,
  W29_25 = 742.95,
  W30 = 762,
  W36 = 914.4,
  W42 = 1066.8,
  W48 = 1219.2,
  W54 = 1371.6,
  W60 = 1524,
  W66 = 1676.4,
  W72 = 1828.8,
  W78 = 1981.2,
  W84 = 2133.6,
  W90 = 2286,
  W96 = 2438.4,
}

export const adjustableDoorHandingOptions = [
  {
    label: msg({ id: 'handing.left', message: 'Left' }),
    value: Handing.left,
  },
  {
    label: msg({ id: 'handing.right', message: 'Right' }),
    value: Handing.right,
  },
]
